import bugsnag from "@bugsnag/js";
import { bugsnag_key, release_stage } from "../env";
import bugsnagReact from "@bugsnag/plugin-react";
import React from "react";
import { shouldReport, groupingHash } from "./errorReporting";

let ErrorBoundary = ({ children }) => {
  return children;
};

// eslint-disable-next-line no-console
let notifyError = console.debug;

// Reduce a Bugsnag report to the fields our reporting policy cares about.
// Axios exposes its transient-failure code on the original error.
const describeReport = report => ({
  errorClass: report.errorClass,
  errorMessage: report.errorMessage,
  code: report.originalError && report.originalError.code,
  stacktrace: report.stacktrace
});

if (!!bugsnag_key) {
  const bugsnagClient = bugsnag({
    apiKey: bugsnag_key,
    releaseStage: release_stage,
    notifyReleaseStages: ["production", "acceptance", "development"],
    filters: [
      "birthDate",
      "emailAddress",
      "iban",
      "phoneNumber",
      "family",
      "given",
      "letters",
      "postalCode",
      "houseNumber",
      "houseNumberAddition",
      "city",
      "street"
    ],
    beforeSend: report => {
      // Drop transient failures and known third-party/browser noise before
      // they ever create a group to snooze. 4xx/5xx still report — grouping
      // (below) keeps their volume manageable.
      if (!shouldReport(describeReport(report))) {
        report.ignore();
        return;
      }

      if (report.originalError instanceof Object) {
        report.updateMetaData("response", report.originalError.response || "");
        report.updateMetaData("error", report.originalError);
      }

      // Group by stable route, not by entity: strip the origin, query string
      // and dynamic id segments so per-invitation failures collapse into one
      // group per route instead of one "new" error per link.
      report.groupingHash = groupingHash(report.errorClass, window.location.toString());
    }
  });

  bugsnagClient.use(bugsnagReact, React);

  ErrorBoundary = bugsnagClient.getPlugin("react");

  notifyError = bugsnagClient.notify;
}

export { ErrorBoundary, notifyError };
